import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Heart } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const { setGoogleAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash || location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        
        if (!match) {
          console.error('No session_id in URL');
          navigate('/auth', { replace: true });
          return;
        }

        const sessionId = match[1];
        
        const response = await axios.post(
          `${API}/auth/google/callback`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const { token, user } = response.data;
        
        if (token && user) {
          setGoogleAuth(token, user);
          navigate('/dashboard', { replace: true });
        } else {
          // Fallback: old response format without token
          navigate('/dashboard', { replace: true, state: { user: response.data.user } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/auth', { replace: true });
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FDFBF7] via-[#F0F7F4] to-[#FCF0EC] flex items-center justify-center">
      <div className="text-center">
        <Heart className="w-12 h-12 text-primary fill-primary mx-auto mb-4 animate-pulse" />
        <p className="text-slate-600">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
